import React, { useEffect, useState } from "react";
import { BlurWrapperWithSpan } from "../Utils/CustomComponent";

const RtfViewer = ({ rtfContent }) => {
  const [plainText, setPlainText] = useState("");

  useEffect(() => {
    const converter = extractTextFromRTF(rtfContent);
    setPlainText(converter);
  }, [rtfContent]);

  return (
    <BlurWrapperWithSpan>
      <div style={{ maxHeight: "6vh", overflow: "scroll" }}>{plainText}</div>
    </BlurWrapperWithSpan>
  );
};

export default RtfViewer;
function removeFontTable(rtf) {
  const start = rtf?.indexOf("{\\fonttbl");
  if (start === -1) return rtf;

  let depth = 0;
  let i = start;
  // Walk through the string to balance the braces for the font table group.
  for (; i < rtf.length; i++) {
    if (rtf[i] === "{") {
      depth++;
    } else if (rtf[i] === "}") {
      depth--;
      if (depth === 0) break;
    }
  }
  // Remove the entire font table block.
  return rtf.slice(0, start) + rtf.slice(i + 1);
}

export function extractTextFromRTF(rtf) {
  // First, remove the font table group.
  rtf = removeFontTable(rtf);

  // Remove the generator group (which contains extra header info).
  rtf = rtf.replace(/{\\\*\\generator[\s\S]*?}/g, "");

  // Remove header info by taking only what comes after the first paragraph marker.
  const contentStart = rtf.indexOf("\\pard");
  if (contentStart !== -1) {
    rtf = rtf.substring(contentStart);
  }

  // Replace RTF paragraph tags with newlines.
  let text = rtf.replace(/\\par[d]?/g, "\n");

  // Replace hex-encoded characters (e.g. \'e9 becomes é).
  text = text.replace(/\\'([0-9a-fA-F]{2})/g, (match, hex) =>
    String.fromCharCode(parseInt(hex, 16))
  );

  // Remove remaining RTF control words (like \ansi, \deff0, etc.)
  text = text.replace(/\\[a-zA-Z]+\d*\s?/g, "");

  // Remove curly braces.
  text = text.replace(/[{}]/g, "");

  // Clean up extra whitespace.
  text = text.replace(/\n\s*\n/g, "\n").trim();
  text = text.replace(/<style([\s\S]*?)<\/style>/gi, "");
  text = text.replace(/<script([\s\S]*?)<\/script>/gi, "");
  text = text.replace(/<\/div>/gi, "\n");
  text = text.replace(/<\/li>/gi, "\n");
  text = text.replace(/<li>/gi, "  *  ");
  text = text.replace(/<\/ul>/gi, "\n");
  text = text.replace(/<\/p>/gi, "\n");
  text = text.replace(/<br\s*[\/]?>/gi, "\n");
  text = text.replace(/<[^>]+>/gi, "");
  var divContainer = document.createElement("div");
  divContainer.innerHTML = text;
  return divContainer.textContent || divContainer.innerText || "";
  // return text;
}
